<template>
    <div class="cases-box">
        <div class="banner-box">
            <img src="./../assets/img/succ/banner_succ.jpg" alt="">
        </div>
        <div class="cases-cont">
            <h3 class="cases-title">成功案例</h3>
            <ul class="cases-list">
                <li v-for="(item,index) in cases" :key="index">
                    <router-link :to="{name:'CasesDetail',params:{id:item.id}}">
                        <img :src="item.src" alt="">
                        <p>{{item.text}}</p>
                    </router-link>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import succ1 from "./../assets/img/succ/succ_1.jpg";
import succ2 from "./../assets/img/succ/succ_2.jpg";
import succ3 from "./../assets/img/succ/succ_3.jpg";
export default {
  name: "cases",
  data() {
    return {
      cases: [
        {
          text: "社会单位",
          src: succ1,
          id: 1
        },
        {
          text: "消防监督部门",
          src: succ2,
          id: 2
        },
        {
          text: "消防中介服务机构",
          src: succ3,
          id: 3
        }
      ]
    };
  }
};
</script>
<style lang="scss">
.cases-box {
  .cases-cont {
    padding: 0 $padding;
    .cases-list{
        @extend .flex;
        margin-bottom:1rem;
        li{
            margin-left:.32rem;
            font-size: .24rem;
            text-align: center;
            &:first-child{
                margin-left:0;
            }
        }
        img {
            width:2.1rem;
            margin-bottom:.1rem;
        }
    }
    
  }
  .cases-title {
    font-size: 0.3rem;
    margin: 0.3rem 0;
    text-align: center;
  }
}
</style>
